import { Method } from '../../data/DataUtils.js';
import * as DataUtils from '../../data/DataUtils.js';
import * as DTOs from '../DTOs/TorneoSedesDTOs.js';

export const DeleteItem = async (idPadre, idItem) => {
  return await DataUtils.SaveObject(Method.DELETE, 'torneos/' + idPadre + '/sedes/' + idItem, null);
};

export const GetItem = async (idPadre, idItem) => {
  return DataUtils.FetchObject('torneos/' + idPadre + '/sedes/' + idItem);
};

export const GetListaItems = async (idPadre) => {
  return DataUtils.FetchLista('torneos/' + idPadre + '/sedes');
};

export const PostItem = async (idPadre, datosItem) => {
  const response = await DataUtils.SaveObject(
    Method.POST,
    'torneos/' + idPadre + '/sedes',
    DTOs.saveItem(datosItem)
  );
  // Devolver el id de la respuesta si existe, sino el id del país
  return response && response.id ? response.id : datosItem.pais.id;
};

export const PutItem = async (idPadre, datosItem) => {
  await DataUtils.SaveObject(
    Method.PUT,
    'torneos/' + idPadre + '/sedes/' + datosItem.id,
    DTOs.saveItem(datosItem)
  );
  return datosItem.id;
};
